const config = {
    Environment: 'prod',
    UserPoolId: 'eu-central-1_rBRYbSIvp',
    ClientId: '5898lt5ffbq0tcomv5v2n2g8e5',
    IdentityPoolId: 'eu-central-1:3b3c1e1d-62e7-4cbd-b610-52a0e8033093',
    Region: 'eu-central-1',
    Bucket: 'prod-recapify-infra-eu-central-1-127214199851',
    KBBucket: 'prod-recapify-infra-eu-central-1-127214199851-kb',
    FeatureRequestsFunctionArn: 'arn:aws:lambda:eu-central-1:127214199851:function:prod-recapify-infra-FeatureRequestsFunction-LJRTBSTAQV9D',
    CostTrackingFunctionArn: 'arn:aws:lambda:eu-central-1:127214199851:function:prod-recapify-infra-CostTrackingFunction-a0WglVgbzPp7',
    StripePaymentFunctionArn: 'arn:aws:lambda:eu-central-1:127214199851:function:prod-recapify-infra-StripePaymentFunction-292u9ZMQYRpt',
    UserSettingsFunctionArn: 'arn:aws:lambda:eu-central-1:127214199851:function:prod-recapify-infra-UserSettingsFunction-TBcPLCu1wYHl',
    CloseAccountFunctionArn: 'arn:aws:lambda:eu-central-1:127214199851:function:prod-recapify-infra-close-account',
    StripePublishableKey: 'pk_live_51SOxXfC5xrQzL7yPytt3YqKyQjTVSE8l7UDGdpKQ7Qlj2lJzBFvjsKIZqj0xAb5FgiHUxp1NAOBR13wilap50GlT00Gdlt9jEH',
    KnowledgeBaseQueryFunctionArn: 'arn:aws:lambda:eu-central-1:127214199851:function:prod-recapify-infra-KnowledgeBaseQueryFunction-YBfVOfVHbXEd',
    KnowledgeBaseRAGFunctionArn: 'arn:aws:lambda:eu-central-1:127214199851:function:prod-recapify-infra-KnowledgeBaseRAGFunction-NcT72h1R9uHD',
    ContactFormFunctionUrl: 'https://tvueamngw7fq3lkngw33npusvi0ajmne.lambda-url.eu-central-1.on.aws/',
    RecordingsIndexFunctionArn: 'arn:aws:lambda:eu-central-1:127214199851:function:prod-recapify-infra-RecordingsIndexFunction-JzHuYoPgTncK',
};

export default config;
